module.exports = "/_next/static/images/d9a182c0f4fd4cae050d5fe2905b8029-hero-variant-b-mobile.jpg";